function waitForElement(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElement('.rivo-external-login-button').then((btn) => {
    // Remove Rivo's reactive HTML binding so it can't overwrite our label
    btn.removeAttribute('rivo-ax-html');

    const applyTranslatedLabel = () => {
        if (window.customerStrings && window.customerStrings.log_in) {
            btn.textContent = window.customerStrings.log_in;
        }
    };

    // Apply label once immediately
    applyTranslatedLabel();

    // If Rivo re-renders the button text, force it back to our translation
    const textObserver = new MutationObserver(() => {
        applyTranslatedLabel();
    });

    textObserver.observe(btn, {
        childList: true,
        characterData: true,
        subtree: true,
    });

    // Remember initial href as a fallback
    const initialHref = btn.getAttribute('href') || btn.href || '';

    btn.addEventListener('click', (e) => {
        e.preventDefault();

        // Prefer the current href on the element; fall back to the initial one
        const rawHref = btn.getAttribute('href') || btn.href || initialHref;
        if (!rawHref) return;

        const htmlLang = document.documentElement.lang
            || window.Shopify?.locale
            || window.localeInfo?.language
            || 'de';

        const locale = htmlLang.split('-')[0].toLowerCase();

        let region = window.localeInfo?.country || htmlLang.split('-')[1]?.toUpperCase();

        if (!region) {
            const hostTld = window.location.hostname.split('.').pop().toUpperCase();
            region = hostTld.length === 2 ? hostTld : (locale === 'de' ? 'DE' : '');
        }

        const url = new URL(rawHref, window.location.origin);
        url.searchParams.set("locale", locale);
        if (region) {
            url.searchParams.set("region_country", region);
        }

        window.location.href = url.toString();
    });
});

// Handle translation for the Rivo Shop Pay login button text
waitForElement('.rivo-shop-pay-login-text').then((textSpan) => {
    const applyTranslatedLabel = () => {
        if (window.customerStrings && window.customerStrings.log_in) {
            textSpan.textContent = window.customerStrings.log_in;
        }
    };

    // Apply label once immediately
    applyTranslatedLabel();

    // If Rivo re-renders the button text, force it back to our translation
    const textObserver = new MutationObserver(() => {
        applyTranslatedLabel();
    });

    textObserver.observe(textSpan, {
        childList: true,
        characterData: true,
        subtree: true,
    });
});